import React, { useState, useRef, useEffect, useCallback } from 'react';
import { GoogleMap, useLoadScript, Marker, Autocomplete, InfoWindow } from '@react-google-maps/api';
import { GOOGLE_MAPS_API, UW_TACOMA_GEOLOCATION } from '../../../environment_variable';
import { AWS_API_REQUEST, ENDPOINTS, BELLEVUE_ADDITIONAL_DATA, BACKDOOR_FIREBASE_TOKEN, S3_BUCKET_CLIENT_URL } from '../../../configurations';
import axios from 'axios';
import moment from 'moment'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { FormControl } from '@mui/material';
import './styles.css';
import toast from 'react-hot-toast';
import { SupportedCities, SupportedZoneTypes } from '../Constants';

import {handleAddressToGeolocation} from './../Utilities';
import ParkingSpotPieChart from './ParkingSpotPieChart'; // Import the ParkingPieChart component
import BugReportDialog from './BugReportDialog';

import { auth } from '../../../config/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Hourglass } from 'react-loader-spinner';
import DownloadCDS from './DownloadCDS';


const libraries = ['places'];

const mapContainerStyle = {
  width: 'calc(100vw - 400px)', // Adjust the width to leave space for the dialog
  //width: '100vw',
  height: '89vh',
  position: 'relative',
};

const center = {
  lat: UW_TACOMA_GEOLOCATION.Latitude, // default latitude
  lng: UW_TACOMA_GEOLOCATION.Longitude, // default longitude
};

// Define color constants
// const COLOR_GREEN = "green";
// const COLOR_ORANGE = "#FFA500";
// const COLOR_YELLOW = "#FFFF00";
// const COLOR_BLUE = "#0000FF";
// const COLOR_RED = "#FF0000";

// Define color for zone types


const InventoryManagement = () => {

  const [map, setMap] = useState(null); // State to store the GoogleMap instance

  const [isLoading, setIsLoading] = useState(false); // Add isLoading state
  const [address, setAddress] = useState('');
  const [showAllSigns, setShowAllSigns] = useState(false);
  const [destinationCoords, setDestinationCoords] = useState({lat: null, lng: null});
  const [city, setCity] = useState('');

  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedPlaceId, setSelectedPlaceId] = useState(null);

  //const [arrivalDateTimeValue, setArrivalDateTimeValue] = useState(moment().format('YYYY-MM-DDTHH:mm:ss'));
  const [arrivalDateTimeValue, setArrivalDateTimeValue] = useState(moment());
  const [departureHour, setDepartureHour] = useState(0);
  const [departureMinute, setDepartureMinute] = useState(0);
  const [parkingSpots, setParkingSpots] = useState({});
  const [parkingZones, setParkingZones] = useState([]);

  const [freeParkingCount, setFreeParkingCount] = useState(0);
  const [paidParkingCount, setPaidParkingCount] = useState(0);
  const [handicapParkingCount, setHandicapParkingCount] = useState(0);
  const [loadingParkingCount, setLoadingParkingCount] = useState(0);
  const [noParkingCount, setNoParkingCount] = useState(0);
  const [busParkingCount, setBusParkingCount] = useState(0);
  const [passengerCount, setPassengerCount] = useState(0);
  const [transitCount, setTransitCount] = useState(0);
  const [electricVehicleCount, setElectricVehicleCount] = useState(0);
  const [unregulatedCount, setUnregulatedCount] = useState(0);

  const [crossWalkCount, setCrossWalkCount] = useState(0);
  const [shuttleStopCount, setShuttleStopCount] = useState(0);
  const [evCount, setEvCount] = useState(0);
  const [numEvSpot, setNumEvSpot] = useState(0);

  const [parkingSignsInfo, setParkingSignsInfo] = useState([]);
  const [additionalCurbInfo, setAdditionalCurbInfo] = useState([]);
  const [uniqueZoneTypes, setUniqueZoneTypes] = useState([]);

  const [showBugReportDialog, setShowBugReportDialog] = useState(false);
  const [markerInfo, setMarkerInfo] = useState({});

  const mapRef = useRef();
  const polylineRefs = useRef([]);
  const autocompleteRef = useRef(null); // Create a useRef hook

  const polylineAdditonalDataRefs = useRef([]);

  // useEffect hook to log parkingSignsInfo whenever it changes
  useEffect(() => {
    //console.log('......parkingSignsInfo', parkingSignsInfo);
    if (city && city === SupportedCities.BELLEVUE) {
      setShowAllSigns(true);
    }
  }, [parkingSignsInfo, city]);

  // useEffect(() => {
  //   fetchAdditionalZoneData();
  // }, []);

  /**
   * Determine the color of a specific parking zone based on allowed time, zone type, and parking signs
   * @param {string} allowedTime - The allowed parking time.
   * @param {string} zoneType - The type of the parking zone.
   * @param {Array} parkingSigns - The parking signs associated with the zone.
   * @returns {string} The color for the polyline.
   */
  const determinePolylineColor = useCallback((allowedTime, zoneType, parkingSigns) => {

    // Default color: red (no parking zones)
    let color = SupportedZoneTypes.NO_PARKING.color;
  
    // Determine color based on the zone type
    switch (zoneType) {

      case SupportedZoneTypes.FREE.value:
        color = SupportedZoneTypes.FREE.color;

        // Free doesn't have zero
        if (allowedTime === 'LO' || (allowedTime <= 15 && allowedTime > 0)) {
          //console.log('EXIST', allowedTime);
          color = SupportedZoneTypes.LOADING.color;
        } 
        // else {
        //   if (showAllSigns && (parseInt(allowedTime) === 0)) {
        //     color = SupportedZoneTypes.NO_PARKING.color;
        //   } else if (parseInt(allowedTime) > 30) {
        //     color = SupportedZoneTypes.FREE.color;
        //   }
        // }
        break;

      case SupportedZoneTypes.TRANSIT.value:
        color = SupportedZoneTypes.TRANSIT.color;
        break;      
      case SupportedZoneTypes.PASSENGER.value:
        color = SupportedZoneTypes.PASSENGER.color;
        break;
      case SupportedZoneTypes.NO_PARKING.value:
        color = SupportedZoneTypes.NO_PARKING.color;
        break;
      case SupportedZoneTypes.CROSSING.value:
        color = SupportedZoneTypes.CROSSING.color;
        break;
      case SupportedZoneTypes.ENTRANCE.value:
        color = SupportedZoneTypes.ENTRANCE.color;
        break;
      case SupportedZoneTypes.NO_PARKING_FILL.value:
        color = SupportedZoneTypes.NO_PARKING_FILL.color;
        break;
      case SupportedZoneTypes.LOADING.value:
        color = SupportedZoneTypes.LOADING.color;
        break;
      case SupportedZoneTypes.HANDICAP.value:
        color = SupportedZoneTypes.HANDICAP.color;
        break;
      case SupportedZoneTypes.PAY.value:
        color = SupportedZoneTypes.PAY.color;
        break;
      case SupportedZoneTypes.BUS.value:
        color = SupportedZoneTypes.BUS.color;
        break;
      case "shuttle":
        color = SupportedZoneTypes.SHUTTLE_STOP.color;
        break;
      case "electric_vehicle":
        color = SupportedZoneTypes.EV.color;
        break;
      case "unregulated":
        color = SupportedZoneTypes.UNREGULATED.color;
        break;
      default:
        color = SupportedZoneTypes.NO_PARKING.color;
        break;
    }
  
    // Additional logic to refine colors based on allowed time
    // if (parseInt(allowedTime) === 0 && showAllSigns) {
    //   color = SupportedZoneTypes.NO_PARKING.color;
    // }
  
    return color;
  }, [showAllSigns]);

  // Add polyline to the map and display number of car spots
  
  // Create polyline for additional data
  useEffect(() => {
    // Ensure that the Google Maps API has loaded
    if (!window.google || !window.google.maps) {
      //console.error("Google Maps API has not loaded yet.");
      return;
    }
    // Clear existing polylines
    polylineAdditonalDataRefs.current.forEach((polyline) => {
      polyline.setMap(null);
    });
  
    // Initialize a new array for storing polylines
    polylineAdditonalDataRefs.current = [];

    // Create an InfoWindow instance to be reused for all polylines
    const infoWindow = new window.google.maps.InfoWindow();
    const defaultStrokeWeight = 3;
    const highlightedStrokeWeight = 10; // Increase stroke weight for highlighting

    additionalCurbInfo.forEach((signInfo) => {

      if (signInfo.zone_type === 'Crosswalk' || signInfo.zone_type === 'Shuttle Stop' || signInfo.zone_type === 'Electric Vehicles' || signInfo.zone_type === 'Transit Only') {
        return;
      }

      let strokeColor = SupportedZoneTypes.UNREGULATED.color;

      switch (signInfo.zone_type) {
        case 'Bus Stop':
          strokeColor = SupportedZoneTypes.BUS.color;
          break;
        // case 'Transit Only':
        //   strokeColor = SupportedZoneTypes.TRANSIT.color;
        //   break;
        // case 'Crosswalk':
        //   strokeColor = SupportedZoneTypes.CROSSWALK.color;
        //   break;
        // case 'Electric Vehicles':
        //   strokeColor = SupportedZoneTypes.EV.color;
        //   break;
        // case 'Shuttle Stop':
        //   strokeColor = SupportedZoneTypes.SHUTTLE_STOP.color;
        //   break;
        default:
          strokeColor = SupportedZoneTypes.UNREGULATED.color;
          break;
      }

      const polyline = new window.google.maps.Polyline({
        path: [
          { lat: signInfo.curb_start_lat, lng: signInfo.curb_start_lng },
          { lat: signInfo.curb_end_lat, lng: signInfo.curb_end_lng }
        ],
        geodesic: false,
        strokeColor: strokeColor,
        strokeOpacity: 1,
        strokeWeight: 5,
        map: map // Add the polyline to the map
      });

      // Store the polyline reference for future cleanup
      polylineAdditonalDataRefs.current.push(polyline);

      polyline.addListener('mouseover', (e) => {
        // Increase stroke weight for highlighting
        polyline.setOptions({ strokeWeight: highlightedStrokeWeight });
  
        // Create a styled message for the number of parking spots
        const parkingSpotMessage = `
          <div style="background-color: ${strokeColor}; padding: 8px; color: ${signInfo.zone_type === "Electric Vehicles" ? 'black' : 'white'}; border-radius: 4px;">
            <p><b>${signInfo.zone_type}</b></p>
          </div>`;

        // Set the content and position of the InfoWindow
        infoWindow.setContent(parkingSpotMessage);
        infoWindow.setPosition(e.latLng);
  
        // Open the InfoWindow on the map
        infoWindow.open(map);
      });
  
      polyline.addListener('mouseout', () => {
        // Restore the original stroke weight
        polyline.setOptions({ strokeWeight: defaultStrokeWeight });
  
        // Close the InfoWindow when the mouse leaves the polyline
        infoWindow.close();
      });
      
    });

     // Cleanup function to remove polylines and InfoWindow
     return () => {
      polylineAdditonalDataRefs.current.forEach((polyline) => polyline.setMap(null));
    };
  }, [additionalCurbInfo, map]);


  useEffect(() => {
    // Ensure that the Google Maps API has loaded
    if (!window.google || !window.google.maps) {
      //console.error("Google Maps API has not loaded yet.");
      return;
    }

    // Clear existing polylines
    Object.values(polylineRefs.current).forEach((polylineArray) => {
      polylineArray?.forEach((polyline) => {
        polyline.setMap(null);
      });
    });

    // Initialize a new array for storing polylines
    polylineRefs.current = {};
  
    // Create an InfoWindow instance to be reused for all polylines
    const infoWindow = new window.google.maps.InfoWindow();
  
    // Create new polylines based on parkingSignsInfo
    parkingSignsInfo.forEach((signInfo, index) => {
      const strokeColor = determinePolylineColor(signInfo.allowedTime, signInfo.zoneType, signInfo.parkingSigns);
      const defaultStrokeWeight = 3;
      const highlightedStrokeWeight = 10; // Increase stroke weight for highlighting
  
      const polyline = new window.google.maps.Polyline({
        path: [
          { lat: signInfo.orderedCoords[0][0], lng: signInfo.orderedCoords[0][1] },
          { lat: signInfo.orderedCoords[1][0], lng: signInfo.orderedCoords[1][1] }
        ],
        geodesic: false,
        strokeColor: strokeColor,
        strokeOpacity: 1,
        strokeWeight: defaultStrokeWeight,
        map: map // Add the polyline to the map
      });

      // Ensure the zone type key exists and is an array
      if (!polylineRefs.current[signInfo.zoneType]) {
        polylineRefs.current[signInfo.zoneType] = [];
      }
      polylineRefs.current[signInfo.zoneType].push(polyline);

      // Add event listeners to the polyline to show the InfoWindow on hover and increase stroke weight
      //if (signInfo.zoneType !== SupportedZoneTypes.NO_PARKING.value) {
        polyline.addListener('mouseover', (e) => {
          // Increase stroke weight for highlighting
          polyline.setOptions({ strokeWeight: highlightedStrokeWeight });

          // Title
          let title = signInfo.zoneType === SupportedZoneTypes.FREE.value ? 'Time Limited Parking'
            : signInfo.zoneType === SupportedZoneTypes.LOADING.value ? 'Loading Zone'
            : signInfo.zoneType === SupportedZoneTypes.PASSENGER.value ? 'Passenger Drop-Off/Pick-Up Zone'
            : signInfo.zoneType === SupportedZoneTypes.NO_PARKING.value ? "No Parking Zone"
            : signInfo.zoneType === SupportedZoneTypes.NO_PARKING_FILL.value ? "No Parking Zone"
            : signInfo.zoneType === "electric_vehicle"? "Electric Vehicles"
            : signInfo.zoneType === "transit"? "Transit Zone"
            : signInfo.zoneType === "unregulated" ? "Unregulated Zone"
            : signInfo.zoneType === "shuttle" ? "Shuttle Stop"
            : signInfo.zoneType === SupportedZoneTypes.CROSSING.value ? "No Parking Zone"
            : signInfo.zoneType === SupportedZoneTypes.ENTRANCE.value ? "No Parking Zone"
            : '';
    
          // Create a styled message for the number of parking spots
          const parkingSpotMessage = `
            <div style="background-color: ${strokeColor}; padding: 4px; color: ${signInfo.zoneType === "electric_vehicle" ? 'black' : 'white'}; border-radius: 4px;">
              <p><b>${title}</b></p>
              ${(signInfo.zoneType !== SupportedZoneTypes.NO_PARKING.value
                && signInfo.zoneType !== SupportedZoneTypes.NO_PARKING_FILL.value
                && signInfo.zoneType !== 'transit' && signInfo.zoneType !== SupportedZoneTypes.PASSENGER.value
                && signInfo.zoneType !== 'unregulated' && signInfo.zoneType !== 'shuttle'
              ) ? `<p>Parking Spots: ${signInfo.parkingSpots}</p>` : ""}

              <p>Zone ID: ${signInfo.zoneId}</p>
            </div>`;

          // Set the content and position of the InfoWindow
          infoWindow.setContent(parkingSpotMessage);
          infoWindow.setPosition(e.latLng);
    
          // Open the InfoWindow on the map
          infoWindow.open(map);
        });
    
        polyline.addListener('mouseout', () => {
          // Restore the original stroke weight
          polyline.setOptions({ strokeWeight: defaultStrokeWeight });
    
          // Close the InfoWindow when the mouse leaves the polyline
          infoWindow.close();
        });
    });
  
    // Cleanup function to remove polylines and InfoWindow
    return () => {
      Object.values(polylineRefs.current).forEach((polylineArray) => {
        polylineArray?.forEach((polyline) => polyline.setMap(null));
      });
      infoWindow.close();
    };
  }, [parkingSignsInfo, map, determinePolylineColor]);

  const handleMouseEnter = (zoneType) => {
    if (polylineRefs.current[zoneType]) {
      polylineRefs.current[zoneType].forEach((polyline) => {
        polyline.setOptions({ strokeWeight: 5 });
      });
    }
  };

  const handleMouseLeave = (zoneType) => {
    if (polylineRefs.current[zoneType]) {
      polylineRefs.current[zoneType].forEach((polyline) => {
        polyline.setOptions({ strokeWeight: 2 });
      });
    }
  };

  
  useEffect(() => {
    //console.log('Selected Marker Changed:', selectedMarker);
  }, [selectedMarker]);

  const zoomToLocation = (parkingZones) => {
    if (map && parkingZones.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();
      parkingZones.forEach(zone => {
        bounds.extend(new window.google.maps.LatLng(zone.srcLatLng[0], zone.srcLatLng[1]));
        zone.parkingSigns.forEach(sign => {
          bounds.extend(new window.google.maps.LatLng(sign.latLng[0], sign.latLng[1]));
        });
      });
      map.fitBounds(bounds);
    }
  };  

  const handleDepartureHour = (event) => {
    setDepartureHour(event.target.value);
  };

  const handleDepartureMinute = (event) => {
    setDepartureMinute(event.target.value);
  }
 
  const fetchAdditionalZoneData = async (token) => {

    // https://api.aioparking.com/get_nearby_zone_objects?latitude=47.615613&longitude=-122.1955025&database=BellevueZone
    //let apiURL = 'https://api.aioparking.com/get_nearby_zone_objects?latitude=47.615613&longitude=-122.1955025&database=BellevueZone';

    const headers = {
      Authorization: `${token}`
    };

    try {

      const response = await axios.get(BELLEVUE_ADDITIONAL_DATA, { headers });
      const responseData = response.data.zone_objs;
      //console.log('response', responseData);
      setAdditionalCurbInfo(responseData);

      // Extract unique zone types
      const zoneTypes = [...new Set(responseData.map(zone => zone.zone_type))];
      setUniqueZoneTypes(zoneTypes);
      //['No Parking', 'Plant Strip', 'Bikeshare Zone', 'Driveway', 'Regulated Parking (assign time limit)', '15-Minute Load/Unload', 'Bus Stop', 'Other (Notes)', 'No Parking - Fire Lane', 'Transit Only', 'Crosswalk', 'Bike Lane', 'Electric Vehicles', 'Under Construction', '3 Minute Passenger Load/Unload', 'Shuttle Stop', '30-Minute Load/Unload', 'Hardscape']
      //console.log('zone types', zoneTypes);

      let currentBusParkingCount = 0;
      let currentCrossWalkCount = 0, currentEvCount = 0;
      let numOfEvSpots = 0;

      responseData.forEach(zone => {
        if (zone.zone_type === 'Bus Stop') {
          currentBusParkingCount++;
        } else if (zone.zone_type.includes("Crosswalk")) {
          currentCrossWalkCount++;
        } else if (zone.zone_type.includes("Electric Vehicles")) {
          currentEvCount++;
          numOfEvSpots += zone.parking_spots;
        }
        });

      //console.log('busParkingCount', currentBusParkingCount);

      // Update state with the counts
      setBusParkingCount(currentBusParkingCount);
      setCrossWalkCount(currentCrossWalkCount);
      setEvCount(currentEvCount);
      setNumEvSpot(numOfEvSpots);

    } catch (error) {
      //console.error('Error fetching additional parking zones:', error);
      alert('We apologize for the inconvenience. Please try again later.');
    } finally {
      setShowAllSigns(false);
    }
  }

  const loginAndGetToken = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, 'putthidasamrith@gmail.com', '123456');
      const user = userCredential.user;
      const token = await user.getIdToken();
      return token;
    } catch (error) {
      console.error('Error logging in and getting token:', error);
      throw new Error('Authentication failed');
    }
  };

  const handleSearch = async () => {
    if (address.trim() === '') {
      alert('Please enter the address');
      return;
    }

    setIsLoading(true);
    setShowAllSigns(false);

    const { latitude, longitude, city } = await handleAddressToGeolocation(address, setDestinationCoords, toast);

    if (city && city === SupportedCities.BELLEVUE) {
      setShowAllSigns(true);
    }

    if (latitude !== -1 && longitude !== -1 && city !== '') {
      const arrivalDateTime = arrivalDateTimeValue.format('YYYY-MM-DD[T]HH:mm:ss');
      const searchRange = 3;
      const database = city === SupportedCities.BELLEVUE ? 'BellevueZone' : 'MontrealStreet';
      const state = 'WA';
      const desireTime = departureHour * 60 + departureMinute;

      const cloud_url = AWS_API_REQUEST + ENDPOINTS.GET_NEARBY_PARKING_SIGN_ZONE;
      let apiUrl = `${cloud_url}?latitude=${latitude}&longitude=${longitude}&searchRange=${searchRange}&database=${database}&arrivalDatetime=${arrivalDateTime}&city=${city}&state=${state}&desireTime=${desireTime}`;
      //console.log('API', apiUrl);

      try {
        //const token = await loginAndGetToken();
        const headers = {
          Authorization: `${BACKDOOR_FIREBASE_TOKEN}`
        };
        //console.log(headers);

        if (city === SupportedCities.BELLEVUE) {
          try {
            // Start timing the API call
            //const startTimeAPI1 = performance.now();
            //console.log("API1 - Start calling cloud API for fetching additional Bellevue data")
            await fetchAdditionalZoneData(BACKDOOR_FIREBASE_TOKEN);

            // End timing the API call
            //const endTimeAPI1 = performance.now();
            //console.log(`API1 call took ${endTimeAPI1 - startTimeAPI1} milliseconds`);

          } catch (error) {
            //console.error('Error in fetchAdditionalZoneData:', error);
          }
        }

        // Start timing the API call
        // const startTime = performance.now();
        // console.log('API2 - Start calling API to get all the data')
        const response = await axios.get(apiUrl, { headers });

        // End timing the API call
        // const endTime = performance.now();
        // console.log(`API2 call took ${endTime - startTime} milliseconds`);

        const { parkingSpots, parkingZones } = response.data;
        //console.log('Response', response.data.parkingZones.length);
        
        setParkingSpots(parkingSpots);
        setParkingZones(parkingZones);

        let freeCount = 0,
          paidCount = 0,
          handicapCount = 0,
          loadingCount = 0,
          noParkCount = 0,
          curr_shuttle = 0,
          curr_evCount = 0,
          curr_passengerCount = 0,
          curr_transitCount = 0,
          curr_unregulatedCount = 0;

        parkingZones.forEach(zone => {
          switch (zone.zoneType) {
            case 'free':
              freeCount++;
              if (zone.allowedTime === 0) {
                noParkCount++;
              } else if (zone.allowedTime === 'LO') {
                loadingCount++;
              }
              break;
            case 'paid':
              paidCount++;
              break;
            case 'handicap':
              handicapCount++;
              break;
            case 'load':
              loadingCount++;
              break;
            case 'passenger':
              curr_passengerCount++;
              break;
            case 'transit':
              curr_transitCount++;
              break;
            case 'no_parking':
              noParkCount++;
              break;
            case SupportedZoneTypes.NO_PARKING_FILL.value:
              noParkCount++;
              break;
            case SupportedZoneTypes.CROSSING.value:
              noParkCount++;
              break;
            case SupportedZoneTypes.ENTRANCE.value:
              noParkCount++;
              break;
            case 'electric_vehicle':
              curr_evCount++;
              break;
            case 'shuttle':
              curr_shuttle++;
              break;
            case 'unregulated':
              curr_unregulatedCount++;
              break;
            default:
              break;
          }
        });

        const returnParkingZoneInfo = parkingZones.map(zone => {
          const parkingSigns = zone.parkingSigns ? zone.parkingSigns : [];

          return {
            allowedTime: zone.allowedTime,
            dstLatLng: zone.dstLatLng,
            parkingSigns: parkingSigns,
            parkingSpots: zone.parkingSpots,
            srcLatLng: zone.srcLatLng,
            zoneType: zone.zoneType,
            zoneId: zone.zoneId,
            orderedCoords: zone.orderedCoords,
          };
        });

        setParkingSignsInfo(returnParkingZoneInfo);
        zoomToLocation(returnParkingZoneInfo);

        setCity(city);

        setFreeParkingCount(freeCount);
        setPaidParkingCount(paidCount);
        setHandicapParkingCount(handicapCount);
        setLoadingParkingCount(loadingCount);
        setNoParkingCount(noParkCount);
        setPassengerCount(curr_passengerCount);
        setTransitCount(curr_transitCount);
        setElectricVehicleCount(curr_evCount);
        setUnregulatedCount(curr_unregulatedCount);
        setShuttleStopCount(curr_shuttle);

      } catch (error) {
        //console.error('Error fetching parking zones data in: ' + city, error);
        alert('We do not have data in the city you searched for yet. Please try again later.');
      } finally {
        setIsLoading(false);
        setShowAllSigns(false);
      }
    } else {
      setIsLoading(false);
      alert('We apologize for the inconvenience. Please try again later.');
    }
  };

  const handleDateTimeChange = (newValue) => {
    setArrivalDateTimeValue(newValue);
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: GOOGLE_MAPS_API,
    libraries,
  });

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading maps</div>;
  }

  const handleLoad = (autocomplete) => {
    // Save a reference to the Autocomplete service
    //console.log('Autocomplete loaded:', autocomplete);
    autocompleteRef.current = autocomplete; // Save the autocomplete reference
  };
  
  const handlePlaceChanged = () => {
    // Get the selected place from the Autocomplete service
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace();
      //console.log('Place selected:', place);
  
      // Update the address state with the formatted address
      setAddress(place.formatted_address);
    }
  };

  const getMarkerIconUrl = (color) => {
    const colorToUrl = {
      '#32CD32': "https://maps.google.com/mapfiles/ms/icons/green-dot.png", // Bright green for FREE
      '#4682B4': "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",  // Blue for PAY
      '#0000FF': "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",  // Blue for HANDICAP
      '#FF0000': "https://maps.google.com/mapfiles/ms/icons/red-dot.png",    // Red for NO PARKING
      '#FFA500': "https://maps.google.com/mapfiles/ms/icons/orange-dot.png",// Orange for LOADING
      '#00bfff': "https://maps.google.com/mapfiles/ms/icons/ltblue-dot.png",// Light blue for BUS
      '#008080': "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",  // Teal for PASSENGER
      '#6a329f': "https://maps.google.com/mapfiles/ms/icons/purple-dot.png",// Purple for TRANSIT
      '#de37d0': "https://maps.google.com/mapfiles/ms/icons/pink-dot.png",  // Pink for CROSSWALK
      'yellow': "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png", // Yellow for DRIVEWAY and EV
      '#FF69B4': "https://maps.google.com/mapfiles/ms/icons/pink-dot.png", // Custom pink for SHUTTLE STOP
      '#808080': "https://maps.google.com/mapfiles/ms/icons/grey-dot.png"   // Gray for UNREGULATED
    };
  
    return colorToUrl[color] || "https://maps.google.com/mapfiles/ms/icons/grey-dot.png"; // Default to grey if color not found
  }

  const handleMarkerClick = (placeId) => {
    const marker = uniquePlaceIds.get(placeId);
    setMarkerInfo(marker);
    setSelectedPlaceId(placeId);
  };

  // const uniquePlaceIds = new Map();

  // parkingSignsInfo.forEach(signInfo => {
  //   if (signInfo.parkingSigns && signInfo.parkingSigns.length > 0) {
  //     signInfo.parkingSigns.forEach(parkingSign => {
  //       if (!uniquePlaceIds.has(parkingSign.placeId)) {
  //         uniquePlaceIds.set(parkingSign.placeId, { ...parkingSign, signInfo });
  //       }
  //     });
  //   }
  // });
  // Define priority for zone types
  const zoneTypePriority = {
    "free": 1,
    "load": 2,
    "electric_vehicle": 3,
    "handicap": 4,
    "pay": 5,
    "bus": 6,
    "passenger": 7,
    "transit": 8,
    "crosswalk": 9,
    "driveway": 10,
    "shuttle": 11,
    "no_parking": 12,
    "crossing": 13,
    "entrance": 14,
    "unregulated": 15
  };

  const uniquePlaceIds = new Map();

  parkingSignsInfo.forEach(signInfo => {
    if (signInfo.parkingSigns && signInfo.parkingSigns.length > 0) {
      signInfo.parkingSigns.forEach(parkingSign => {
        if (!uniquePlaceIds.has(parkingSign.placeId)) {
          uniquePlaceIds.set(parkingSign.placeId, {
            placeId: parkingSign.placeId,
            latLng: parkingSign.latLng,
            zoneTypes: new Set([signInfo.zoneType]),
            allowedTime: signInfo.allowedTime,
            parkingSigns: [parkingSign]
          });
        } else {
          const existing = uniquePlaceIds.get(parkingSign.placeId);
          existing.parkingSigns.push(parkingSign);
          existing.zoneTypes.add(signInfo.zoneType);
        }
      });
    }
  });
  
  const getHighestPriorityZoneType = (zoneTypes) => {
    let highestPriorityType = "unregulated";
    let highestPriorityValue = zoneTypePriority[highestPriorityType];
  
    zoneTypes.forEach(zoneType => {
      if (zoneTypePriority[zoneType] < highestPriorityValue) {
        highestPriorityType = zoneType;
        highestPriorityValue = zoneTypePriority[zoneType];
      }
    });
  
    return highestPriorityType;
  };

  const handleReportBugClick = () => {
    setShowBugReportDialog(true);
  };

  const handleCloseBugReportDialog = () => {
    setShowBugReportDialog(false);
  };

  //console.log('parkingSignsInfo', JSON.stringify(parkingSignsInfo));

  return (

    <div style={{ position: 'relative' }}>

      {/* Tooltip div for displaying the number of spots */}
      {/* <div id="tooltip" className="absolute p-2 bg-white rounded shadow-lg text-gray-800 font-semibold text-sm leading-tight" style={{ display: 'none', zIndex: 1, pointerEvents: 'none' }}></div> */}

      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column', // Arrange spinner and text vertically
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          zIndex: 1000
        }}>
          <Hourglass
            visible={true}
            height="80"
            width="80"
            ariaLabel="hourglass-loading"
            wrapperStyle={{}}
            wrapperClass=""
            colors={['#306cce', '#72a1ed']}
          />

          {/* <Oval
            height={80}
            width={80}
            color="#4fa94d"
            wrapperStyle={{}}
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          /> */}
          <p style={{
            marginTop: '20px', // Add some space between spinner and text
            color: '#333', // Text color
            fontSize: '16px', // Text size
            fontWeight: 'bold' // Bold text
          }}>
            Please wait while we&apos;re getting the data...
          </p>
        </div>
      )}

      <GoogleMap  
        mapContainerStyle={mapContainerStyle}
        zoom={10}
        center={center}
        onLoad={mapInstance => setMap(mapInstance)} // Save the GoogleMap instance
        ref={mapRef}
        mapTypeId="satellite" // Set the map type to satellite
      >

        {/* Render markers for each parking sign */}
        {[...uniquePlaceIds.values()].map(({ placeId, latLng, zoneTypes, allowedTime, parkingSigns }, index) => {
          const highestPriorityZoneType = getHighestPriorityZoneType(zoneTypes);
          return (
            <Marker
              key={index}
              position={{
                lat: latLng[0],
                lng: latLng[1]
              }}
              onClick={() => handleMarkerClick(placeId)}
              icon={{
                url: getMarkerIconUrl(determinePolylineColor(allowedTime, highestPriorityZoneType, parkingSigns)),
                scaledSize: new window.google.maps.Size(40, 40) // Adjust the size of the marker icon if necessary
              }}
            />
          );
        })}

        {/* Conditionally render InfoWindow for the selected marker */}
        {selectedPlaceId && (
          <InfoWindow
            position={{
              lat: uniquePlaceIds.get(selectedPlaceId).latLng[0],
              lng: uniquePlaceIds.get(selectedPlaceId).latLng[1]
            }}
            onCloseClick={() => setSelectedPlaceId(null)}
            options={{
              pixelOffset: new window.google.maps.Size(0, -40),
            }}
          >
            <div style={{ maxWidth: '400px', textAlign: 'center' }}>
              {/* Display PlaceID in the middle of the info window */}
              <h3 style={{ textAlign: 'center', marginBottom: '10px' }} className="mb-2 text-lg font-semibold">
                Place ID: {selectedPlaceId}
              </h3>

              {/* Display parking signs */}
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', textAlign: 'center' }}>
                {(() => {
                  const uniqueSigns = new Map();
                  parkingSignsInfo
                    .flatMap(signInfo => signInfo.parkingSigns)
                    .filter(parkingSign => parkingSign.placeId === selectedPlaceId)
                    .forEach(parkingSign => {
                      if (!uniqueSigns.has(parkingSign.id)) {
                        uniqueSigns.set(parkingSign.id, parkingSign);
                      }
                    });

                  return Array.from(uniqueSigns.values()).map((parkingSign, idx) => (
                    <div key={idx} className="infoWindowImageContainer" style={{ flexBasis: '45%', margin: '10px', textAlign: 'center' }}>
                      {parkingSign.imgSrc && (
                        <div>
                          <img
                            //src={`https://api.aioparking.com${parkingSign.imgSrc}`} /media/img/0Ow6tbcIzxYskHUIbgRy0J6jkxn2/20230810_092447_00090F_20230810_092447_00090F_320_0.jpg
                            src={`${S3_BUCKET_CLIENT_URL}/${parkingSign.imgSrc.split('/').pop()}`}
                            alt={`Parking Sign ${idx}`}
                            className="infoWindowImage"
                            style={{ width: '100px', height: '150px', cursor: 'pointer', display: 'block', margin: '0 auto' }}
                          />

                          {/* Example S3 URL: https://ai4curb.s3.us-west-2.amazonaws.com/washington/bellevue/20230810_092447_00090F_20230810_092447_00090F_3170_0.jpg */}
                          {/* <p>{`${S3_BUCKET_CLIENT_URL}/${parkingSign.imgSrc.split('/').pop()}`}</p> */}
                        </div>
                      )}
                      {/* Additional text */}
                      <div className="additionalText" style={{ marginTop: '5px', textAlign: 'center' }}>
                        {parkingSign.text && <p><strong>Sign Rule:</strong> {parkingSign.text}</p>}
                        {city === "Montreal" && parkingSign.orgText && (
                          <p><strong>Original Text:</strong> {parkingSign.orgText}</p>
                        )}
                        {parkingSign.id && <p><strong>Sign ID:</strong> {parkingSign.id}</p>}
                        {parkingSign.uploadTime
                          ? <p><strong>Upload Time:</strong> {moment(parkingSign.uploadTime).format('MMMM DD, YYYY')}</p>
                          : ''
                        }
                      </div>
                    </div>
                  ));
                })()}
              </div>

              {/* Actions */}
              <div className="flex justify-center items-center h-full">
                <div className="group relative">
                  <button
                    type="submit"
                    onClick={handleReportBugClick}
                    className="inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-red-700 bg-red-700 px-4 py-2 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90"
                  >
                    <span>Report Bugs</span>
                    <svg className="hi-mini hi-information-circle inline-block size-5 text-white group-hover:text-primary-500"
                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" clipRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"/>
                    </svg>
                  </button>

                </div>

              </div>
              {/* END Actions */}

            </div>
          </InfoWindow>
        )}

      </GoogleMap>


      {showBugReportDialog && (
        <BugReportDialog
          open={showBugReportDialog}
          onClose={handleCloseBugReportDialog}
          markerInfo={markerInfo}
          searchedAddress={address}
          arrivalDateTime={arrivalDateTimeValue.format('YYYY-MM-DD[T]HH:mm:ss')}
          desiredParkingTime={(departureHour * 60 + departureMinute) + ' mins'}
        />
      )}
      

      {/* <div className="absolute top-0 right-0 bg-white p-8 rounded-lg w-96 h-full overflow-y-auto"> */}
      <div>
        {/* Cards: Simple */}
        <div className="searchCard">

          {/* Card Body */}
          <div className="grow p-2">

            <div className="mb-2">
              <p className="text-md font-semibold">Address<span className="text-red-500">*</span></p>
              <Autocomplete onLoad={handleLoad} onPlaceChanged={handlePlaceChanged}>
                <input required
                  type="text"
                  placeholder="Enter search area"
                  className="w-full border p-2 rounded"
                  onChange={(searchValue) => setAddress(searchValue.target.value)}
                />
              </Autocomplete>
            </div>

            <div className="mb-2">
              <p className="text-md font-semibold">Estimated Arrival Date and Time</p>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  value={arrivalDateTimeValue}
                  className="w-full border p-2 rounded"
                  //onChange={(newValue) => setArrivalDateTimeValue(newValue)}
                  onChange={handleDateTimeChange}
                  inputFormat="YYYY-MM-DD HH:mm" // Define the input format
                  //defaultValue={moment(new Date())}
                />
              </LocalizationProvider>
            </div>

            {
            //!showAllSigns && 
            <div className="mb-0">
              <p className="text-md font-semibold">Parking/Loading Time</p>
              <FormControl sx={{ minWidth: 120 }}>
                <Select
                  value={departureHour}
                  onChange={handleDepartureHour}
                  //label="Hour"
                  inputProps={{ 'aria-label': 'Without label' }}
                  defaultValue={0}
                >
                  <MenuItem value={0}>0 h</MenuItem>
                  <MenuItem value={1}>1 h</MenuItem>
                  <MenuItem value={2}>2 h</MenuItem>
                  <MenuItem value={4}>4 h</MenuItem>
                  <MenuItem value={6}>6 h</MenuItem>
                </Select>
              </FormControl>

              <FormControl sx={{ ml: 1, minWidth: 120 }}>
                <Select
                  value={departureMinute}
                  onChange={handleDepartureMinute}
                  //label="Minute"
                  inputProps={{ 'aria-label': 'Without label' }}
                  defaultValue={0}
                >
                  <MenuItem value={0}>0m</MenuItem>
                  <MenuItem value={15}>15m</MenuItem>
                  <MenuItem value={30}>30m</MenuItem>
                  <MenuItem value={45}>45m</MenuItem>

                </Select>
              </FormControl>

            </div>}

          </div>
          {/* END Card Body */}

          {/* Card Footer */}
          <div className="bg-gray-50 px-2 py-1 text-sm text-gray-600 dark:bg-gray-700/50 dark:text-gray-400">
            <button
              onClick={handleSearch}
              disabled={isLoading}
              className={`inline-flex w-full items-center justify-center space-x-2 rounded-lg border border-teal-700 bg-teal-700 px-6 py-2 font-semibold leading-6 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white focus:ring focus:ring-primary-400 focus:ring-opacity-50 active:border-primary-700 active:bg-primary-700 dark:focus:ring-primary-400 dark:focus:ring-opacity-90 
                ${isLoading ? 'cursor-not-allowed bg-gray-300 text-gray-600' : ''}`}
            >
              {isLoading ? <>Loading...</> : <>Search</>}
            </button>
          </div>
          {/* END Card Footer */}

        </div>
        {/* END Cards: Simple */}
    

        <div className="mt-1 resultsCard">

          {/** Display number of signs after performing search */}
          <h2 className="text-lg font-semibold mb-2">Search Results</h2>
          {/* <h3>Number of signs within the searched areas</h3> */}

            {/* <div className="mb-2">
              <FormGroup row>
                <FormControlLabel label="Free Parking" control={<Checkbox checked={freePaymentType} onChange={(newValue) => setFreePaymentType(newValue.target.checked)}/>} />
                <FormControlLabel label="Paid Parking" control={<Checkbox checked={paidPaymentType} onChange={(newValue) => setPaidPaymentType(newValue.target.checked)}/>}/>
              </FormGroup>
            </div> */}
          
          {
          //  !isLoading && showAllSigns ?

          //   <div className="mb-0 pt-0">
          //     {/* Render the ParkingPieChart component and pass the data as props */}
          //     <ParkingSpotPieChart data={pieChartData} />
          //     {/* Other content of the InventoryManagement component */}
          //   </div>

          //   :

            <div>
              {/* Render Free Parking with green background */}
              <div style={{ backgroundColor: SupportedZoneTypes.FREE.color, color: 'white', padding: '5px', marginBottom: '5px' }}
                onMouseEnter={() => handleMouseEnter(SupportedZoneTypes.FREE.value)}
                onMouseLeave={() => handleMouseLeave(SupportedZoneTypes.FREE.value)}>
                <p style={{ margin: '0' }}>Time Limited Parking: {parkingSpots.free} spot{parkingSpots.free > 1 ? 's' : ''} in {freeParkingCount} zone{freeParkingCount > 1 ? 's' : ''}</p>
              </div>

              {/* <div style={{ backgroundColor: SupportedZoneTypes.FREE.color, color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Regular Free: {parkingSpots.free} spot{parkingSpots.free > 1 ? 's' : ''} in {freeParkingCount} zone{freeParkingCount > 1 ? 's' : ''}</p>
              </div> */}

              <div style={{ backgroundColor: SupportedZoneTypes.PAY.color,  color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Pay: {parkingSpots.pay} spot{parkingSpots.pay > 1 ? 's' : ''} in {paidParkingCount} zone{paidParkingCount > 1 ? 's' : ''}</p>
              </div>
              <div style={{ backgroundColor: SupportedZoneTypes.HANDICAP.color, color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Dedicated Handicap: {parkingSpots.handicap} spot{parkingSpots.handicap > 1 ? 's' : ''} in {handicapParkingCount} zone{handicapParkingCount > 1 ? 's' : ''}</p>
              </div>
              <div style={{ backgroundColor: SupportedZoneTypes.LOADING.color, padding: '5px', marginBottom: '5px' }}
                onMouseEnter={() => handleMouseEnter(SupportedZoneTypes.LOADING.value)}
                onMouseLeave={() => handleMouseLeave(SupportedZoneTypes.LOADING.value)}>
                <p style={{ margin: '0' }}>Dedicated Loading: {parkingSpots.load} spot{parkingSpots.load > 1 ? 's' : ''} in {loadingParkingCount} zone{loadingParkingCount > 1 ? 's' : ''}</p>
                {/* <p style={{ margin: '0' }}>Dedicated Loading: {loadingParkingCount} spot{loadingParkingCount > 1 ? 's' : ''} in {loadingParkingCount} zone{loadingParkingCount > 1 ? 's' : ''}</p> */}
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.NO_PARKING.color, padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0', color: 'white' }}>No Parking: {noParkingCount} zone{noParkingCount > 1 ? 's' : ''}</p>
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.BUS.color,  color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Bus Stop: {busParkingCount} zone{busParkingCount > 1 ? 's' : ''}</p>
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.PASSENGER.color, color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Passenger Pick-up/Drop-Off: {parkingSpots.passenger} spot{parkingSpots.passenger > 1 ? 's' : ''} in {passengerCount} zone{passengerCount > 1 ? 's' : ''}</p>
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.TRANSIT.color,  color: 'white', padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0' }}>Transit: {transitCount} zone{transitCount > 1 ? 's' : ''}</p>
              </div>

              {/* <div style={{ backgroundColor: SupportedZoneTypes.CROSSWALK.color, padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0', color: 'white' }}>Crosswalks: {crossWalkCount} zone{crossWalkCount > 1 ? 's' : ''}</p>
              </div> */}

              <div style={{ backgroundColor: SupportedZoneTypes.EV.color, padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0', color: 'black' }}>EV: {parkingSpots.electric_vehicle} spot{parkingSpots.electric_vehicle > 1 ? 's' : ''} in {electricVehicleCount} zone{electricVehicleCount > 1 ? 's' : ''}</p>
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.SHUTTLE_STOP.color, padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0', color: 'black' }}>Shuttle Stop: {shuttleStopCount} zone{shuttleStopCount > 1 ? 's' : ''}</p>
              </div>

              <div style={{ backgroundColor: SupportedZoneTypes.UNREGULATED.color, padding: '5px', marginBottom: '5px' }}>
                <p style={{ margin: '0', color: 'white' }}>Unregulated: {unregulatedCount} zone{unregulatedCount > 1 ? 's' : ''}</p>
              </div>
            </div>
            
          }

          {/* Pie chart */}
          {
            !isLoading && showAllSigns ?
            <div className="mb-0">
              {/* Render the ParkingPieChart component and pass the data as props */}
              <ParkingSpotPieChart data={[
                ["Parking Type", "Number of Zones"],
                ["Time Limited Parking Zones", freeParkingCount],
                ["Pay Parking Zones", paidParkingCount],
                ["Handicap Zones", handicapParkingCount],
                ["Loading Zones", loadingParkingCount],
                ["No Parking Zones", noParkingCount],
                ["Bus Zones", busParkingCount],
                ["Transit Zones", transitCount],
                ["Passenger Pick-up/Drop-off", passengerCount],
                ["Electric Vehicles", electricVehicleCount],
                // ["Crosswalk", crossWalkCount],
                ["Shuttle Stop", shuttleStopCount]
              ]} />
              {/* Other content of the InventoryManagement component */}
            </div>

            :
            <div>
              <p></p>
            </div>

          }

          {/** Display download links */}
          <DownloadCDS />
        
        </div>

        

      </div>

    </div>
  );
};

export default InventoryManagement;